import apiService from '../utils/apiService';

import {
  GET_INSTITUTION_TYPE_LIST_START,
  GET_INSTITUTION_TYPE_LIST,
  GET_INSTITUTION_TYPE_LIST_ERROR,
} from './types';

import { institutionTypeFindAllPath } from '../constants/apiEndpoints';

const getInstitutionTypeListStart = () => {
  return {
    type: GET_INSTITUTION_TYPE_LIST_START,
  };
};
const getInstitutionTypeListSuccessfully = (data) => {
  return {
    type: GET_INSTITUTION_TYPE_LIST,
    payload: data,
  };
};
const getInstitutionTypeListUnsuccessfully = (err) => {
  return {
    type: GET_INSTITUTION_TYPE_LIST_ERROR,
    payload: err,
  };
};

export const findAllInstitutionType = () => {
  return (dispatch) => {
    dispatch(getInstitutionTypeListStart());
    return apiService
      .get(institutionTypeFindAllPath())
      .then((response) => {
        dispatch(getInstitutionTypeListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getInstitutionTypeListUnsuccessfully(err?.response?.data));
      });
  };
};
